export const ICON_WIDTH = 20
export const ICON_INDENT = 10
export const BORDER_ADJUSTMENT = 2
